import { call, fork, select } from 'redux-saga/effects';
import { initSframeClientSaga } from 'features/e2ee/sagas/initSframeClientSaga';
import { generateRoomE2eeCode } from 'features/e2ee/sagas/generateRoomE2eeCode';
import { bulkExchangeEncryptionKeysSaga } from 'features/e2ee/sagas/bulkExchangeEncryptionKeysSaga';
import { bulkComputeEncryptionKeysSaga } from 'features/e2ee/sagas/bulkComputeEncryptionKeysSaga';
import { exchangeEncryptionKeysSaga } from 'features/e2ee/sagas/exchangeEncryptionKeysSaga';
import { RoomJoinedPayload } from 'features/room/types';
import { AbstractE2eeUser } from 'features/e2ee/types';
import { transformToAbstractE2ee } from 'features/e2ee/utils/transformUsersToAbstractE2ee';
import { selectMainRoomId } from 'features/breakout-rooms/breakoutRoomsSlice';

export function* setupE2eeSaga(data: RoomJoinedPayload) {
  yield fork(generateRoomE2eeCode);

  const {
    users,
    usersAwaitingEntry,
    user: { e2eeId },
    recorder,
    restreamer,
    roomId,
  } = data;

  yield call(initSframeClientSaga, e2eeId!);

  yield fork(bulkExchangeEncryptionKeysSaga, users);

  if (recorder) {
    yield fork(exchangeEncryptionKeysSaga, {
      id: recorder.id,
      roomId,
      e2eePublicKey: recorder.e2eePublicKey,
    });
  }

  if (restreamer) {
    yield fork(exchangeEncryptionKeysSaga, {
      id: restreamer.id,
      roomId,
      e2eePublicKey: restreamer.e2eePublicKey,
    });
  }

  if (usersAwaitingEntry.length) {
    const mainRoomId: string = yield select(selectMainRoomId);
    const waitingUsers: AbstractE2eeUser[] = yield call(
      transformToAbstractE2ee,
      usersAwaitingEntry,
      () => mainRoomId
    );
    yield call(bulkComputeEncryptionKeysSaga, waitingUsers);
  }
}
